import { useGetBodyMapEntriesQuery } from "../../../services/api/bodyMapApi";
import { useResidentContext } from "../../residents/provider/ResidentProvider";
import { BodyMapEntryStatusEnums } from "../../../services/api/types/bodyMap/BodyMapEntryStatusEnums";
import usePagination from "ui/molecules/pagination/usePagination";

interface Props {
  entryStatus: BodyMapEntryStatusEnums;
}

export function useGetBodyMapEntries({ entryStatus }: Props) {
  const { residentId } = useResidentContext();
  const { currentPage, handlePageChange } = usePagination();

  const { data, isLoading } = useGetBodyMapEntriesQuery(
    {
      residentId: residentId!,
      filter: { status: entryStatus },
      page: currentPage,
    },
    { skip: !residentId },
  );

  return { data, isLoading, handlePageChange };
}
